export default __webpack_public_path__ + "locales/uk-UA/ConvertPasswordDialog.json?hash=0fe3ac27e4c8872efb70b68a4a7a1ac9";